import { PairName } from '@ui/assets/config/trade-pair-listings';
import { isProdEnv } from '@ui/constants/env';
import { ChainId } from '@ui/types/chain';
import { BareTradePair } from '@ui/types/tradePair';
import { objectFromEntries } from '@ui/utils/objectFromEntries';

import { pairInfoControllerApi } from '../../clients/clients';
import { GetPairsRequest, PagedPairResponse } from '../../generated';
import { toServerBlockChain } from '../../utils';
import { toPair } from './toPair';

const getKey = (params: GetPairsQuery.Param) => {
  return ['pairInfoControllerApi.getPairs', params];
};
const getFn =
  ({ chainId, ...params }: GetPairsQuery.Param) =>
  async () => {
    const rawResponse = await pairInfoControllerApi.getPairs({
      ...params,
      blockChain: toServerBlockChain(chainId),
      // use to filter readiness of pairs
      // uat: false, return pairs that is under QA verification AND verified
      // sta: false, return pairs that is under QA verification AND verified
      // prod: true, return pairs that is verified
      isReadyToDisplay: isProdEnv
    });

    return {
      ...rawResponse,
      content: objectFromEntries(
        rawResponse.content
          .map((raw) => {
            const pair = toPair(raw);
            if (!pair) return null;

            return [pair.pairName, pair] as const;
          })
          .filter((v): v is NonNullable<typeof v> => !!v),
      ),
    };
  };
export const getPairsQuery = {
  getKey,
  getFn,
};

export namespace GetPairsQuery {
  export type Param = Omit<
    GetPairsRequest,
    'blockChain' | 'tags' | 'isReadyToDisplay'
  > & {
    chainId: ChainId;
    // NOTE: in auto listing, use backend extract symbols
    // symbol:
    // tags:
  };

  export type Response = Omit<PagedPairResponse, 'content'> & {
    content: Record<PairName, BareTradePair>;
  };
}
